"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginationDTO = void 0;
class PaginationDTO {
    current;
    total;
    content;
}
exports.PaginationDTO = PaginationDTO;
